import { CrudFilter, CrudFilters, DataProvider } from '@refinedev/core';
import { generateFilter, generateSortParams } from './utils';
import type { SearchQuery } from './utils';
import ERPUserAPIClient from './clients/erpuserapiclient';
import CrudAPIClient from './clients/crudapiclient';
import SkuApiClient from './clients/skuapiclient';
import SkuUploadApiClient from './clients/upload/skuuploadapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { axiosInstance, type PortalAxiosRequestConfig } from './clients/axios';
import CategoryAPIClient from './clients/categoryapiclient';
import DCItemUploadAPIClient from './clients/upload/dcitemuploadapiclient';
import DeliveryChallanItemAPIClient from './clients/deliverychallanitemapiclient';
import DeliveryChallanAPIClient from './clients/deliverychallanapiclient';
import DeliveryChallanSkuAPIClient from './clients/deliverychallanskuapiclient';
import DeliveryChallanLotAPIClient from './clients/deliverychallanlotapiclient';
import DeliveryChallanCommentAPIClient from './clients/deliverychallancommentapiclient';
import SkuDiscountUploadAPIClient from './clients/upload/skudiscountuploadapiclient';
import SkuMrpTaxUploadAPIClient from './clients/upload/skumrptaxuploadapiclient';
import SkuTagsUploadAPIClient from './clients/upload/skutagsuploadclient';
import SkuStatusUploadAPIClient from './clients/upload/skustatusuploadclient';
import OrderLineItemAPIClient from './clients/orderlineitemapiclient';
import StoreCreditApiClient from './clients/storecreditapiclient';
import VendorApiClient from './clients/vendorapiclient';
import OrderPackageAPIClient from './clients/orderpackageapiclient';
import OrderAPIClient from './clients/orderapiclient';
import PaymentAPIClient from './clients/paymentapiclient';
import PayoutApiClient from './clients/payoutapiclient';
import InventoryApiClient from './clients/inventoryapiclient';
import ReturnAPIClient from './clients/returnapiclient';
import CouponApiClient from './clients/couponapiclient';
import PromotionApiClient from './clients/promotionapiclient';
import ProductApiClient from './clients/productapiclient';
import ServiceabilityAPIClient from './clients/serviceabilityapiclient';
import RefundAPIClient from './clients/refundapiclient';
import StyleUploadClient from './clients/upload/styleuploadclient';
import StyleBundleUploadAPIClient from './clients/upload/stylebundleuploadapiclient';
import StyleBundleRemoveAPIClient from './clients/upload/stylebundleremoveapiclient';
import StockTransferApiClient from './clients/stocktransferapiclient';
import GatepassOrderApiClient from './clients/gatepassorderapiclient';
import GatepassApiClient from './clients/gatepassapiclient';
import ShelfTransferApiClient from './clients/shelftransferapiclient';
import ManifestApiClient from './clients/manifestapiclient';
import CollectionApiClient from './clients/collectionapiclient';
import CollectionStyleUploadApiClient from './clients/upload/collectionstyleuploadapiclient';
import SortStrategyApiClient from './clients/sortstrategyapiclient';
import CoyuCreditApiClient from './clients/CoyuCreditApi';
import CrmAdminApiClient from './clients/crmadminapiclient';
import RiderCashHandoverApiClient from './clients/ridercashhandoverapiclient';
import RiderLatestStateApiClient from './clients/riderlateststateapiclient';

const apiClients: any = {
  org: new CrudAPIClient(GATEWAY_API_URL + '/org'),
  assets: new CrudAPIClient(GATEWAY_API_URL + '/asset'),
  customers: new CrudAPIClient(GATEWAY_API_URL + '/identity/customer'),
  b2bcustomers: new CrudAPIClient(GATEWAY_API_URL + '/identity/b2b-customer'),
  erpusers: new ERPUserAPIClient('admin'),
  vendorusers: new ERPUserAPIClient('vendor'),
  storeusers: new ERPUserAPIClient('storestaff'),
  vendors: new VendorApiClient(),
  coupons: new CouponApiClient(),
  'coupon-usage': new CrudAPIClient(GATEWAY_API_URL + '/coupon-usage'),
  promotions: new PromotionApiClient(),
  roles: new CrudAPIClient(GATEWAY_API_URL + '/role'),
  categories: new CategoryAPIClient(),
  skuupload: new SkuUploadApiClient(),
  skudiscountupload: new SkuDiscountUploadAPIClient(),
  skumrptaxupload: new SkuMrpTaxUploadAPIClient(),
  skutagsupload: new SkuTagsUploadAPIClient(),
  styleupload: new StyleUploadClient(),
  skustatusupload: new SkuStatusUploadAPIClient(),
  stylebundleupload: new StyleBundleUploadAPIClient(),
  stylebundleremove: new StyleBundleRemoveAPIClient(),
  products: new ProductApiClient(),
  skus: new SkuApiClient(),
  wondersoftskus: new SkuApiClient('wondersoft'),
  shopifyskus: new SkuApiClient('shopify'),
  skualbums: new CrudAPIClient(GATEWAY_API_URL + '/skualbum'),
  aialbums: new CrudAPIClient(GATEWAY_API_URL + '/skualbum'),
  pincodes: new CrudAPIClient(GATEWAY_API_URL + '/pincode'),
  facilities: new CrudAPIClient(GATEWAY_API_URL + '/facility'),
  vendorfacilities: new CrudAPIClient(GATEWAY_API_URL + '/facility'),
  saleschannels: new CrudAPIClient(GATEWAY_API_URL + '/saleschannel'),
  paymentterminals: new CrudAPIClient(GATEWAY_API_URL + '/payment/payment-terminal'),
  deliverychallans: new DeliveryChallanAPIClient(),
  dcitemupload: new DCItemUploadAPIClient(),
  dcitems: new DeliveryChallanItemAPIClient(),
  dcskus: new DeliveryChallanSkuAPIClient(),
  dclots: new DeliveryChallanLotAPIClient(),
  dccomments: new DeliveryChallanCommentAPIClient(),
  grn: new DeliveryChallanAPIClient(),
  dclotwondersoft: new DeliveryChallanLotAPIClient('wondersoft'),
  orders: new OrderAPIClient(),
  packages: new OrderPackageAPIClient(),
  lineitems: new OrderLineItemAPIClient(),
  returns: new ReturnAPIClient(),
  'return-courier-exceptions': new ReturnAPIClient(),
  refunds: new RefundAPIClient(),
  'refunds-onhold': new RefundAPIClient(),
  payments: new PaymentAPIClient(),
  payouts: new PayoutApiClient(),
  inventory: new InventoryApiClient(),
  vendorinventory: new InventoryApiClient(),
  purchaseorders: new DeliveryChallanAPIClient(),
  mtopurchaseorders: new DeliveryChallanAPIClient(),
  storecredits: new StoreCreditApiClient(),
  addresses: new CrudAPIClient(GATEWAY_API_URL + '/address'),
  comments: new CrudAPIClient(GATEWAY_API_URL + '/comment'),
  templates: new CrudAPIClient(GATEWAY_API_URL + '/template'),
  serviceability: new ServiceabilityAPIClient(),
  stocktransfer: new StockTransferApiClient(),
  'gatepass-orders': new GatepassOrderApiClient(),
  gatepasses: new GatepassApiClient(),
  'shelf-transfers': new ShelfTransferApiClient(),
  manifests: new ManifestApiClient(),
  'gatepass-manifests': new ManifestApiClient(), // Backward compatibility
  collections: new CollectionApiClient(),
  'collection-style-upload': new CollectionStyleUploadApiClient(),
  'sort-strategies': new SortStrategyApiClient(),
  coyucredit: new CoyuCreditApiClient(),
  ridercashhandover: new RiderCashHandoverApiClient(),
  riderlateststate: new RiderLatestStateApiClient(),
  crmsegments: new CrmAdminApiClient({
    definitionPath: '/api/admin/segments',
    suppressEmptySearch: true,
  }),
  crmjourneys: new CrmAdminApiClient({
    definitionPath: '/api/admin/journeys',
    runsPath: '/api/admin/journeys',
    summaryPath: '/api/admin/journey-runs',
  }),
  crmcampaigns: new CrmAdminApiClient({
    definitionPath: '/api/admin/campaigns',
    runsPath: '/api/admin/campaigns',
    summaryPath: '/api/admin/campaign-runs',
  }),
};

export const getApiClientInstance = (resource: string) => {
  return apiClients[resource];
};

const inFlightGetListRequests = new Map<string, Promise<{ data: any[]; total: number }>>();

const buildInFlightGetListKey = (params: {
  resource: string;
  currentPage: number;
  pageSize: number;
  searchQuery: SearchQuery;
  meta: unknown;
  hasCustomMethod: boolean;
}) => {
  try {
    return JSON.stringify({
      resource: params.resource,
      page: params.currentPage,
      size: params.pageSize,
      query: params.searchQuery,
      meta: params.meta,
      hasCustomMethod: params.hasCustomMethod,
    });
  } catch {
    return undefined;
  }
};

const isFieldCrudFilter = (
  filter: CrudFilter,
): filter is CrudFilter & { field: string; operator: string; value?: unknown } =>
  typeof (filter as Record<string, unknown>)?.field === 'string' &&
  typeof (filter as Record<string, unknown>)?.operator === 'string';

const normalizePackageFilters = (filters?: CrudFilters): CrudFilters | undefined => {
  if (!filters?.length) {
    return filters;
  }

  const toValues = (value: unknown): Array<string> => {
    if (Array.isArray(value)) {
      return value.map(item => String(item));
    }
    if (value === undefined || value === null) {
      return [];
    }
    return [String(value)];
  };

  const allowedValuesByField = new Map<string, Set<string>>();
  filters.forEach(filter => {
    if (!isFieldCrudFilter(filter) || filter.operator !== 'in') {
      return;
    }
    const values = toValues(filter.value);
    if (!values.length) {
      return;
    }
    const existing = allowedValuesByField.get(filter.field);
    if (!existing) {
      allowedValuesByField.set(filter.field, new Set(values));
      return;
    }
    const intersection = new Set(values.filter(value => existing.has(value)));
    allowedValuesByField.set(filter.field, intersection);
  });

  const normalizedFilters: CrudFilters = [];

  filters.forEach(filter => {
    if (!isFieldCrudFilter(filter) || (filter.operator !== 'eq' && filter.operator !== 'in')) {
      normalizedFilters.push(filter);
      return;
    }

    const allowedValues = allowedValuesByField.get(filter.field);
    if (!allowedValues || !allowedValues.size) {
      normalizedFilters.push(filter);
      return;
    }

    if (filter.operator === 'eq') {
      const eqValue = toValues(filter.value)[0];
      if (eqValue && allowedValues.has(eqValue)) {
        normalizedFilters.push(filter);
      }
      return;
    }

    const intersectedValues = toValues(filter.value).filter(value => allowedValues.has(value));
    if (!intersectedValues.length) {
      return;
    }

    normalizedFilters.push({
      ...filter,
      value: intersectedValues,
    } as CrudFilter);
  });

  return normalizedFilters;
};

const getCustomMethodName = (meta: unknown): string | undefined => {
  if (!meta || typeof meta !== 'object') {
    return undefined;
  }
  const method = (meta as { customMethod?: unknown }).customMethod;
  return typeof method === 'string' ? method : undefined;
};

export const restDataProvider: DataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    // console.log('Calling getList for resource', resource);
    const { currentPage = 1, pageSize = 10 } = pagination ?? {};
    const normalizedFilters = resource === 'packages' ? normalizePackageFilters(filters) : filters;
    const queryFilters = generateFilter(normalizedFilters);
    const sortingParams = generateSortParams(sorters);

    const searchQuery: SearchQuery = {};
    searchQuery.filters = queryFilters;
    searchQuery.orderBy = sortingParams.orderBy;
    searchQuery.orderDirection = sortingParams.orderDirection;

    const client: CrudAPIClient = getApiClientInstance(resource);
    if (!client) {
      throw new Error(`No client found for resource ${resource}`);
    }

    const customMethod = getCustomMethodName(meta);
    const shouldDedupeInFlight = resource === 'packages';
    const dedupeKey = shouldDedupeInFlight
      ? buildInFlightGetListKey({
          resource,
          currentPage,
          pageSize,
          searchQuery,
          meta,
          hasCustomMethod: Boolean(customMethod),
        })
      : undefined;

    const runGetList = async (): Promise<{ data: any[]; total: number }> => {
      if (customMethod && typeof (client as any)[customMethod] === 'function') {
        const metaWithPagination = {
          ...meta,
          currentPage,
          pageSize,
          page: currentPage,
        };
        const response = await (client as any)[customMethod](
          sorters ?? [],
          normalizedFilters ?? [],
          undefined,
          undefined,
          undefined,
          metaWithPagination,
        );

        if (
          response &&
          typeof response === 'object' &&
          Array.isArray(response.data) &&
          typeof response.total === 'number'
        ) {
          return response;
        }

        if (
          response &&
          typeof response === 'object' &&
          Array.isArray(response.data) &&
          typeof response.page === 'number' &&
          typeof response.size === 'number'
        ) {
          return response;
        }

        const fallbackEntities = Array.isArray(response) ? response : [];
        const fallbackHasNext: boolean = fallbackEntities.length >= pageSize;

        return {
          data: fallbackEntities,
          total: fallbackHasNext
            ? currentPage * pageSize + 1
            : (currentPage - 1) * pageSize + fallbackEntities.length,
        };
      }

      const response: any = await client.search(searchQuery, currentPage, pageSize, meta);

      let entities: any[];
      let facets: any = undefined;

      if (Array.isArray(response)) {
        entities = response;
      } else if (
        response &&
        typeof response === 'object' &&
        Array.isArray(response.data) &&
        typeof response.total === 'number'
      ) {
        return response;
      } else if (response && typeof response === 'object' && response.results) {
        entities = response.results;
        facets = response.facets;
      } else {
        entities = [];
      }

      const hasNext: boolean = entities.length >= pageSize;

      const result = {
        data: entities,
        total: hasNext
          ? currentPage * pageSize + 1
          : (currentPage - 1) * pageSize + entities.length,
      };

      if (facets) {
        // @ts-expect-error facets is not typed
        result.facets = facets;
      }

      return result;
    };

    if (dedupeKey) {
      const inFlightRequest = inFlightGetListRequests.get(dedupeKey);
      if (inFlightRequest) {
        return inFlightRequest;
      }
    }

    const requestPromise = runGetList();
    if (dedupeKey) {
      const trackedRequest = requestPromise.finally(() => {
        inFlightGetListRequests.delete(dedupeKey);
      });
      inFlightGetListRequests.set(dedupeKey, trackedRequest);
      return trackedRequest;
    }

    return requestPromise;
  },

  getMany: async ({ resource, ids, meta }) => {
    // console.log('Calling getMany for resource', resource);
    if (!ids || ids.length == 0) {
      return {
        data: [],
      };
    }
    const client: CrudAPIClient = getApiClientInstance(resource);
    const entities = await client.findBulk(ids, meta);

    return {
      data: entities,
    };
  },

  create: async ({ resource, variables, meta }) => {
    // console.log('Calling create for resource', resource);
    const client: CrudAPIClient = getApiClientInstance(resource);
    // @ts-expect-error shut up ts
    const entity = await client.create(variables, meta);

    return {
      data: entity,
    };
  },

  createMany: async ({ resource, variables, meta }) => {
    // console.log('Calling createMany for resource', resource);
    const client: CrudAPIClient = getApiClientInstance(resource);
    // @ts-expect-error shut up ts
    const entities = await client.createMany(variables, meta);

    return {
      data: entities,
    };
  },

  update: async ({ resource, id, variables, meta }) => {
    // console.log('Calling update for resource', resource);
    const client: CrudAPIClient = getApiClientInstance(resource);
    // @ts-expect-error shut up ts
    const entity = await client.updateById(id, variables, meta);

    return {
      data: entity,
    };
  },

  getOne: async ({ resource, id, meta }) => {
    // console.log('Calling getOne for resource', resource);
    const client: CrudAPIClient = getApiClientInstance(resource);
    const entity = await client.findById(id, meta);

    return {
      data: entity,
    };
  },

  deleteOne: async ({ resource, id, variables, meta }) => {
    // console.log('Calling deleteOne for resource', resource);
    const client: CrudAPIClient = getApiClientInstance(resource);
    const entity = await client.deleteById(id, meta);
    return {
      data: entity,
    };
  },

  getApiUrl: () => {
    return '';
  },

  custom: async ({ url, method, sorters, filters, payload, query, headers, meta }) => {
    if (!meta?.resource || !meta?.action) {
      throw new Error('Resource and action are required for custom method');
    }

    const client: any = getApiClientInstance(meta.resource);
    if (!client) {
      throw new Error(`No client found for resource ${meta.resource}`);
    }

    if (typeof client[meta.action] === 'function') {
      const data = await client[meta.action](sorters, filters, payload, query, headers, meta);
      return Promise.resolve({ data });
    }

    throw new Error(
      `custom action ${meta.action} for resource ${meta.resource} is not implemented`,
    );
  },
};

/**
 * Worklist tab badges: one package count per named tab, with the package list's own filter
 * normalisation. Fulfillment answers `POST /order/package/search/counts` with `{tab: count}`.
 */
export const fetchPackageSearchCounts = async (
  queries: Record<string, CrudFilters>,
): Promise<Record<string, number>> => {
  const body = Object.fromEntries(
    Object.entries(queries).map(([key, filters]) => [
      key,
      { filters: generateFilter(normalizePackageFilters(filters)) },
    ]),
  );
  // A badge must never end the session: no logout on a 401 from this optional read.
  const config: PortalAxiosRequestConfig = { skipUnauthorizedLogout: true };
  const response = await axiosInstance.post(
    `${GATEWAY_API_URL}/order/package/search/counts`,
    body,
    config,
  );
  if (response.data?.status?.type === 'ERROR' || !response.data?.data) {
    throw new Error(response.data?.status?.message || 'Package counts are unavailable');
  }
  return response.data.data as Record<string, number>;
};

/** Optional exact return workload counts; uses the same filters as return search. */
export const fetchReturnSearchCounts = async (
  queries: Record<string, CrudFilters>,
): Promise<Record<string, number>> => {
  const response = await axiosInstance.post(
    `${GATEWAY_API_URL}/order/return/search/counts`,
    Object.fromEntries(
      Object.entries(queries).map(([key, filters]) => [key, { filters: generateFilter(filters) }]),
    ),
    { skipUnauthorizedLogout: true } as PortalAxiosRequestConfig,
  );
  const counts = response.data?.data;
  if (
    response.data?.success === false ||
    response.data?.status?.type === 'ERROR' ||
    !counts ||
    Object.keys(queries).some(key => !Number.isSafeInteger(counts[key]) || counts[key] < 0)
  ) {
    throw new Error(response.data?.status?.message || 'Return counts are unavailable');
  }
  return counts;
};
